import { defineStore } from 'pinia';

export type AppToastKind = 'ok' | 'info' | 'error';

const DEFAULT_DURATION_MS = 2000;

interface AppToastState {
  kind: AppToastKind;
  open: boolean;
  text: string;
}

let hideTimer = 0;

/** H5 全局轻提示：成功绿、提示黄、失败红。 */
export const useAppToastStore = defineStore('appToast', {
  state: (): AppToastState => ({
    kind: 'ok',
    open: false,
    text: '',
  }),
  actions: {
    show(text: string, kind: AppToastKind = 'ok', durationMs = DEFAULT_DURATION_MS) {
      const message = text.trim();
      if (!message) return;
      this.text = message;
      this.kind = kind;
      this.open = true;
      window.clearTimeout(hideTimer);
      hideTimer = window.setTimeout(() => {
        this.hide();
      }, durationMs);
    },
    ok(text: string) {
      this.show(text, 'ok');
    },
    info(text: string) {
      this.show(text, 'info');
    },
    error(text: string) {
      this.show(text, 'error');
    },
    hide() {
      window.clearTimeout(hideTimer);
      hideTimer = 0;
      this.open = false;
    },
  },
});
